module.exports = __webpack_public_path__ + "static/Mercedes GLE Limo-6ff4ea4b71760ec55e6e8312e52466ad.jpg";